export default "__VITE_ASSET__BHqF$4_z__"